module.exports = __webpack_public_path__ + "img/cimb-bank-img.f35a4366.png";